export const navigationTestIds = {
  container: 'sidebar',
  sidebarOption: 'sidebar-option',
};
